import { ActionFunctionArgs } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api";

export async function AdminManageCoursesAction({
  request,
}: ActionFunctionArgs) {
  const formData = await request.formData();
  const intent = formData.get("intent");

  if (intent === "deleteCourse") {
    const courseId = formData.get("courseId") as string;
    const response = await apiEndpoints.adminDeleteCourse(courseId);
    if (!response.success) {
      return { success: false, error: response.message };
    }
    return { success: true };
  }

  if (intent === "changePublishStatus") {
    const courseId = formData.get("courseId") as string;
    const publishStatus = Number(formData.get("publishStatus"));
    console.log(publishStatus);
    const response = await apiEndpoints.adminUpdateCoursePublishStatus(
      courseId,
      publishStatus,
    );
    if (!response.success) {
      return { success: false, error: response.message };
    }
    return { success: true };
  }

  return { success: false, error: "Unknown intent" };
}
